var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_131_3469)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 46,
    r: 40,
    fill: "url(#paint0_linear_131_3469)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 46,
    r: 39.5,
    stroke: "white",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 24.5C39.949 24.5 31 33.2191 31 43.8516C31 49.2964 33.3037 53.8482 36.5338 57.605C39.7499 61.3456 43.9367 64.3622 47.8564 66.7888L47.8822 66.8048L47.9086 66.8196C48.6992 67.2658 49.592 67.5 50.5 67.5C51.408 67.5 52.3008 67.2658 53.0914 66.8196L53.1144 66.8066L53.137 66.7928C57.071 64.3856 61.2586 61.3592 64.4732 57.6076C67.7006 53.8412 70 49.2784 70 43.8516C70 33.2191 61.051 24.5 50.5 24.5ZM50.5 36C46.0817 36 42.5 39.5817 42.5 44C42.5 48.4182 46.0817 52 50.5 52C54.9182 52 58.5 48.4182 58.5 44C58.5 39.5817 54.9182 36 50.5 36Z",
    fill: "#0C0C83"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_131_3469",
    x: -93.5,
    y: -98,
    width: 288,
    height: 288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 52
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_131_3469"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.890196 0 0 0 0 0.898039 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_131_3469",
    result: "effect2_dropShadow_131_3469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_131_3469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_3469",
    x1: 50.5,
    y1: 6,
    x2: 50.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocationIcon);
export default __webpack_public_path__ + "static/media/no-location-icon.6bda7ad32411de0827302db31c836af2.svg";
export { ForwardRef as ReactComponent };